export function normalizeSearchString(searchString: string) {
	// simple diacritics (accents) removal
	return searchString.normalize('NFD').replace(/\u0300-\u036F/g, '').toLowerCase();
}
